import React from 'react';
import { colors } from '@styleseat/brand';
import { Inline, Box } from '@styleseat/ui';
import { BodyText, Tag } from '../../../../ui';

type TitleProps = {
  color?: string;
  backgroundColor?: string;
  IconComponent?: React.FunctionComponent<{ color?: string; width?: number; height?: number; }>
};

const Title: React.FC<TitleProps> = ({
  children,
  color,
  backgroundColor = colors.chill,
  IconComponent,
}) => (
  <Tag
    color={backgroundColor}
    textColor={color}
    testID="history-item-title"
    textTransform="none"
    fontWeight="400"
    paddingX={0}
    paddingY={0}
    borderRadius={16}
    borderColor={colors.whiteWash}
    borderWidth={1}
    borderStyle="solid"
  >
    <Inline
      space={4}
      paddingX={8}
      paddingY={4}
      alignItems="center"
      minWidth="100%"
    >
      <Box alignItems="flex-end">
        {IconComponent ? <IconComponent width={14} height={14} color={color} /> : null}
      </Box>
      <BodyText appearance="small" weight="bold" color={color}>
        {children}
      </BodyText>
    </Inline>
  </Tag>
);

export default Title;
